module.exports = __webpack_public_path__ + "img/instagram.72a4b561.png";